import { AsyncPaginate } from "react-select-async-paginate";
import makeAnimated from "react-select/animated";
import { getData } from "../../webService/webservice.js";
const MembershipMultiSelectAsync = ({ formData, setFormData }) => {

    const loadMembershipOptions = async (search, loadedOptions, { page }) => {
        const token = localStorage.getItem("Token");

        try {
            const params = {
                page,
                limit: 10,
                search,
            };

            if (formData.storeId) {
                params.storeId = formData.storeId;
            }

            const res = await getData("subscriptions/subscriptions", params, token);

            const pagination = res?.data;
            const membershipList = pagination?.results || [];
            const hasMore = pagination?.currentPage < pagination?.totalPages;

            const options = membershipList.map((sub) => ({
                value: sub._id,
                label: sub.subscriptionName,
            }));

            return {
                options,
                hasMore,
                additional: { page: page + 1 },
            };
        } catch (error) {
            console.error("MEMBERSHIP LOAD ERROR:", error);
            return {
                options: [],
                hasMore: false,
                additional: { page: 1 },
            };
        }
    };

    return (
        <AsyncPaginate
            isMulti
            components={makeAnimated()}
            debounceTimeout={400}
            loadOptions={loadMembershipOptions}
            additional={{ page: 1 }}
            placeholder="Search & select memberships…"
            value={
                (
                    formData?.selectedMemberships?.map((id) => {
                        const matched = formData?.membershipNames?.[id];

                        return {
                            value: id,
                            label: matched || "Membership",
                        };
                    })
                ) || []
            }
            onChange={(selectedOptions) => {
                setFormData((prev) => {
                    const updatedSelected = selectedOptions.map(opt => opt.value);

                    const updatedNames = { ...(prev.membershipNames || {}) };
                    selectedOptions.forEach(opt => {
                        updatedNames[opt.value] = opt.label;
                    });

                    const updatedPrices = selectedOptions.map(opt => {
                        const existing = prev.memberShipPrices?.find(
                            p => p.subscriptionId === opt.value
                        );

                        return {
                            subscriptionId: opt.value,
                            price: existing?.price || 0,
                        };
                    });

                    return {
                        ...prev,
                        selectedMemberships: updatedSelected,
                        membershipNames: updatedNames,
                        memberShipPrices: updatedPrices,
                    };
                });
            }}
        />
    );
};


export default MembershipMultiSelectAsync;
